module.exports = __webpack_public_path__ + "img/android-install-step-2.fb2fffb0.svg";